import { useEffect } from "react";
import { Link } from 'react-router-dom';


export const PartnerForm = () => {
   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               region: "na1",
               portalId: "536350",
               formId: "1ba7757e-31aa-4bba-9150-b0a6dbb6a07b",
               target: '#partnerForm',
            })
         }
      });
   });

   return (
      <div className="footer-form partner-form" id="test">
         <h1>Partnership Enquiry</h1>
         <p>Fill out the form below if you're interested in partnering with us.</p>
         <p>If you're a startup seeking funding, <Link to='/startups'>click here</Link>.</p>
         <div id="partnerForm" />
      </div>
   )
}